import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import classes from './style.module.css';
import { useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import InputText from '../components/InputText';
import CheckboxSwitch from '../components/CheckboxSwitch';
import Select from '../components/Select';
import { setPostNewGame } from '../../../store/games/thunk/setPostNewGame';
import { setGetProviders } from '../../../store/games/thunk/setGetProviders';
import Freespin from '../components/Freespin';

const BALANCE = [{
    label: 'GR-GREEN',
    value: 'GR-GREEN',
}, {
    label: 'GR02-GREEN',
    value: 'GR02-GREEN',
}, {
    label: 'GR-YELLOW',
    value: 'GR-YELLOW',
}]

const GROUP_GAME = [{
    label: 'slots',
    value: 'slots',
}, {
   label: 'live dealer',
   value: 'live dealer' 
}, {
    label: 'Lottery Style Game',
    value: 'lottery style game'
}, {
    label: 'dragon tiger',
    value: 'dragon tiger'
}, {
    label: 'minigame',
    value: 'minigame'
}, {
    label: 'sic bo',
    value: 'sic bo'
}, {
    label: 'keno',
    value: 'keno'
}, {
    label: 'tower',
    value: 'tower'
}, {
    label: 'card',
    value: 'card'
}, {
    label: 'instant win',
    value: 'instant win'
}, {
    label: 'arcade',
    value: 'arcade'
}, {
    label: 'fishing',
    value: 'fishing'
}, {
    label: 'poker',
    value: 'poker'
}, {
    label: 'game_shows',
    value: 'game_shows'
}, {
    label: 'fruit game',
    value: 'fruit game'
}, {
    label: 'fish/shooting',
    value: 'fish/shooting'
}, {
    label: 'andar bahar',
    value: 'andar bahar'
}, {
    label: 'shooting',
    value: 'shooting'
}, {
    label: 'wheel of fortune',
    value: 'wheel of fortune'
}, {
    label: 'bingo',
    value: 'bingo'
}, {
    label: 'videobingos',
    value: 'videobingos'
}, {
    label: 'instant game',
    value: 'instant game'
}, {
    label: 'baccarat',
    value: 'baccarat'
}, {
    label: 'video poker',
    value: 'video poker'
}, {
    label: 'provably fair',
    value: 'provably fair'
}, {
    label: 'table',
    value: 'table'
}, {
    label: 'american roulette',
    value: 'american roulette'
}, {
    label: 'scratch card',
    value: 'scratch card'
}, {
    label: 'board game',
    value: 'board game'
}, {
    label: 'dice',
    value: 'dice'
}, {
    label: 'cluster',
    value: 'cluster'
}, {
    label: 'craps',
    value: 'craps'
}, {
    label: 'lottery',
    value: 'lottery'
}, {
    label: 'table game',
    value: 'table game'
}, {
    label: 'crash',
    value: 'crash'
}, {
    label: 'casual',
    value: 'casual'
}, {
    label: 'roulette',
    value: 'roulette'
}, {
    label: 'scratchcard multilevel',
    value: 'scratchcard multilevel'
}, {
    label: 'blackjack',
    value: 'blackjack'
}, {
    label: 'other',
    value: 'other'
}];

const CreateGames = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetProviders({
            is_deleted: false
        }))
    }, [])

    const handleClick = () => {
        router.history.push('/games/list')
    }

    const { register, handleSubmit, control } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            is_new_provider: false,
            type_balance: '',
            new_provider: '',
            provider_id: '',
            uuid: '',
            image: '',
            name: '',
            platform_uuid: '',
            type: '',
            is_deleted: false,
            is_disabled: true,
            is_have_fs: false,
            is_mobile: false,
            is_desktop: false,
            is_wager: false,
            freespins: [{
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'RUB',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'KZT',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'UZS',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'USD',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'EUR',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'TRY',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'GEL',
                is_disabled: true,
                is_deleted: false
            }, {
                bet_id: 0,
                total_bet: 0,
                denomination: 0,
                currency: 'INR',
                is_disabled: true,
                is_deleted: false
            }],
        },
    })

    const [is_have_fs] = useWatch({
        control,
        name: ['is_have_fs']
    })

    const callbackSuccess = () => {
        alert("Сохранено");
        router.history.push('/games/list')
    }

    const onSubmit = (store) => {
        dispatch(setPostNewGame(store, callbackSuccess));
    }

    const providers = useSelector((state) => state.games.providers);

    return (
        <div className={classes.root}>
            <Title
                label="Добавить игру"
                labelBtn="Назад"
                button={handleClick}
            />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
                <div style={{ width: 323 }}>
                    <Select
                        register={register}
                        name="type_balance"
                        label="Выбрать баланс хранения игры"
                        items={BALANCE}
                        defaultLabel="Выбрать баланс"
                    />
                </div>
                <div style={{ width: 323 }}>
                    <Select
                        register={register}
                        name="provider_id"
                        label="Провайдер"
                        items={providers.map((item) => ({ label: item.name, value: item.id }))}
                        defaultLabel="Выбрать провайдера"
                    />
                </div>
                <div style={{ width: 313 }}>
                    <InputText
                        name="uuid"
                        register={register}
                        label="UUID у агрегатора"
                        placeholder="Введите UUID"
                    />
                </div>
                <div style={{ width: 313 }}>
                    <InputText
                        name="image"
                        register={register}
                        label="Ссылка на изображение"
                        placeholder="Введите ссылку на изображение"
                    />
                </div>
                <div style={{ width: 313 }}>
                    <InputText
                        name="name"
                        register={register}
                        label="Наименование игры"
                        placeholder="Введите наименование"
                    />
                </div>
                <div style={{ width: 313 }}>
                    <InputText
                        name="platform_uuid"
                        register={register}
                        label="UUID на платформе"
                        placeholder="Введите uuid на платформе"
                    />
                </div>
                <div style={{ width: 323 }}>
                    <Select
                        register={register}
                        name="type"
                        label="Группа"
                        items={GROUP_GAME}
                        defaultLabel="Выбрать группу"
                    />
                </div>
                <div className={classes.form__wrap_switch}>
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_deleted"
                        label="Признак удаленности"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_disabled"
                        label="Признак отключения"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_have_fs"
                        label="Признак наличия фриспинов"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_mobile"
                        label="Признак поддержки с телефонов"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_desktop"
                        label="Признак поддержки с десктопа"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_wager"
                        label="Признак отыгрыша вейджера"
                    />
                </div>
                {
                    is_have_fs && (
                        <Freespin
                            control={control}
                            register={register}
                        />
                    )
                }
                
                <div className={classes.form__wrap_submit}>
                    <button type="submit" className={classes.submit}>
                        <span>Сохранить</span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default CreateGames;